const NOT_A_RECIPE_MESSAGES = {
  unintelligible:
    "Let’s try that again. Tell us your ingredients and how you put them together.",
  dish_name_only:
    "Wellby saves your recipes rather than creating new ones. Share the ingredients and steps you'd like to keep.",
  missing_recipe_content:
    "We didn't catch any ingredients or steps yet. Share those and we'll save it for you.",
};

const NOT_A_RECIPE_FALLBACK =
  "Hmm, we couldn't turn that into a recipe just yet. Try sharing the ingredients and steps you'd like to save.";

export function isNotARecipeDetail(detail) {
  if (!detail) return false;
  if (typeof detail === "string") return detail === "not_a_recipe";
  return typeof detail === "object" && detail.code === "not_a_recipe";
}

export function notARecipeMessage(detail) {
  if (!isNotARecipeDetail(detail)) return null;
  const reason = typeof detail === "object" ? detail.reason : null;
  return NOT_A_RECIPE_MESSAGES[reason] || NOT_A_RECIPE_FALLBACK;
}

export function voiceRecipeErrorMessage(detail) {
  const notARecipe = notARecipeMessage(detail);
  if (notARecipe) return notARecipe;
  if (typeof detail === "string") return detail;
  return "Failed to parse recipe. Please try again.";
}
